// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"staticFooterLinks-m__wrapper__26hLx","static-links":"staticFooterLinks-m__static-links__1SUXQ"};